import { gql } from '@apollo/client';

export const AI_HOMEWORK_FIELDS = gql`
  fragment AIHomeworkFields on AIHomework {
    idx
    title
    description
    answer_rubric
    answer_key_image_urls
    page_count
    company_idx
    campus_idx
    class_idx
    user_idx
    ai_homework_group_idx
    ai_homework_group_name
    status
    assigned_count
    idate
    answer_key_pages {
      page_no
      image_url
      rubric_json
    }
  }
`;

export const AI_HOMEWORK_LIST = gql`
  query aiHomeworkList($ai_homework_group_idx: Int, $class_idx: Int, $folderType: String, $q: String, $page: Int, $take: Int) {
    aiHomeworkList(ai_homework_group_idx: $ai_homework_group_idx, class_idx: $class_idx, folderType: $folderType, q: $q, page: $page, take: $take) {
      total
      page
      take
      aiHomeworks {
        idx
        title
        description
        answer_rubric
        answer_key_image_urls
        page_count
        company_idx
        campus_idx
        class_idx
        user_idx
        ai_homework_group_idx
        ai_homework_group_name
        status
        assigned_count
        idate
        group_detail
        answer_key_pages {
          page_no
          image_url
          rubric_json
        }
      }
    }
  }
`;

export const AI_HOMEWORK_SINGLE = gql`
  query aiHomeworkSingle($idx: Int!) {
    aiHomeworkSingle(idx: $idx) {
      ...AIHomeworkFields
    }
  }
  ${AI_HOMEWORK_FIELDS}
`;

export const AI_HOMEWORK_ASSIGNMENT_GROUPS = gql`
  query aiHomeworkAssignmentGroups($campus_idx: Int, $class_idx: Int, $page: Int, $take: Int, $start_date: String, $end_date: String) {
    aiHomeworkAssignmentGroups(campus_idx: $campus_idx, class_idx: $class_idx, page: $page, take: $take, start_date: $start_date, end_date: $end_date) {
      total
      page
      take
      aiHomeworkAssignmentGroups {
        idx
        homework_idx
        homework_group_title
        title
        class_idx
        start_date
        end_date
        start_time
        status
        assigned_count
        idate
        class {
          idx
          name
        }
        ai_homework_date_assignments {
          idx
          ai_homework_user_assignments {
            status
          }
        }
      }
    }
  }
`;

export const AI_HOMEWORK_SINGLE_GROUP = gql`
  query aiHomeworkSingleGroup($idx: Int!) {
    aiHomeworkSingleGroup(idx: $idx) {
      idx
      title
      start_date
      end_date
      start_time
      class {
        idx
        name
      }
      ai_homework_date_assignments {
        idx
        start_date
        limit_time
        data
        ai_homework {
          idx
          title
          description
          answer_rubric
          answer_key_image_urls
          page_count
          group_detail
        }
        ai_homework_user_assignments {
          idx
          status
          user {
            idx
            name
          }
        }
      }
    }
  }
`;

export const AI_HOMEWORK_ASSIGNMENT_GROUP = gql`
  query aiHomeworkAssignmentGroup($idx: Int!) {
    aiHomeworkAssignmentGroup(idx: $idx) {
      idx
      homework_idx
      homework_title
      title
      class_idx
      start_date
      end_date
      start_time
      assigned_count
      assignments {
        idx
        user_idx
        class_idx
        due_date
        status
        student_name
      }
    }
  }
`;

export const AI_HOMEWORK_STUDENT_ASSIGNMENTS = gql`
  query aiHomeworkStudentAssignments($start_date: String, $end_date: String) {
    aiHomeworkStudentAssignments(start_date: $start_date, end_date: $end_date) {
      idx
      homework_idx
      user_idx
      class_idx
      due_date
      status
      homework_title
      homework_description
      page_count
    }
  }
`;

export const AI_HOMEWORK_USER_ASSIGNMENT_DETAILS = gql`
  query aiHomeworkUserAssignmentDetails($idx: Int!) {
    aiHomeworkUserAssignmentDetails(idx: $idx) {
      idx
      class_idx
      start_time
      end_time
      answer
      answer_image_url_json
      result_data
      teacher_review_json
      grading_raw_response_json
      score
      wpm
      status
      rubric_data
      type
      thread_id
      idate
      class {
        name
        class_teacher {
          user {
            name
          }
        }
      }
      ai_homework {
        idx
        title
        description
        answer_rubric
        answer_key_image_urls
        page_count
        group_detail
      }
      user {
        idx
        id
        name
        view_id
        school_grade
        campus {
          name
        }
      }
      ai_homework_date_assignment {
        idx
        start_date
        limit_time
        data
        ai_homework_assignment_group {
          class {
            name
          }
        }
      }
    }
  }
`;

export const AI_HOMEWORK_RESULTS = gql`
  query aiHomeworkResults($class_idx: Int, $homework_idx: Int, $student_idx: Int, $page: Int, $take: Int) {
    aiHomeworkResults(class_idx: $class_idx, homework_idx: $homework_idx, student_idx: $student_idx, page: $page, take: $take) {
      total
      page
      take
      aiHomeworkResults {
        idx
        assignment_idx
        homework_idx
        user_idx
        class_idx
        status
        total_score
        max_score
        submitted_at
        graded_at
        homework_title
        student_name
        error_message
      }
    }
  }
`;

export const AI_HOMEWORK_FINISH_COUNT = gql`
  query aiHomeworkFinishCount($start_date: String, $end_date: String, $type: String!, $class_idx: Int) {
    aiHomeworkFinishCount(start_date: $start_date, end_date: $end_date, type: $type, class_idx: $class_idx)
  }
`;

export const AI_HOMEWORK_GROUP_LIST = gql`
  query aiHomeworkGroupList($class_idx: Int, $folderType: String, $q: String, $level: String, $page: Int, $take: Int) {
    aiHomeworkGroupList(class_idx: $class_idx, folderType: $folderType, q: $q, level: $level, page: $page, take: $take) {
      total
      page
      take
      aiHomeworkGroups {
        idx
        group_name
        description
        level
        data
        user_idx
        campus_idx
        company_idx
        class_idx
        status
        homework_count
        idate
      }
    }
  }
`;

export const AI_HOMEWORK_LIST_BY_GROUP_ID = gql`
  query aiHomeworkListByGroupId($groupIdx: Int!) {
    aiHomeworkListByGroupId(groupIdx: $groupIdx) {
      aiHomeworks {
        idx
        title
        description
        answer_rubric
        answer_key_image_urls
        page_count
        company_idx
        campus_idx
        class_idx
        user_idx
        ai_homework_group_idx
        ai_homework_group_name
        status
        assigned_count
        idate
        answer_key_pages {
          page_no
          image_url
          rubric_json
        }
        group_detail
      }
    }
  }
`;

export const GET_DAILY_AI_HOMEWORK_SCHEDULE = gql`
  query dailyAiHomeworkSchedule($date_string: String!) {
    dailyAiHomeworkSchedule(date_string: $date_string) {
      idx
      start_date
      limit_time
      type
      data
      ai_homework_user_assignments {
        idx
        answer
        status
        ai_homework {
          idx
          title
          description
          __typename
        }
        class {
          idx
          name
          __typename
        }
        user {
          idx
          name
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;

export const AI_HOMEWORK_DATE_ASSIGNMENT_DETAILS = gql`
  query aiHomeworkDateAssignmentDetails($idx: Int!) {
    aiHomeworkDateAssignmentDetails(idx: $idx) {
      idx
      start_date
      limit_time
      data
      type
      ai_homework_user_assignments {
        idx
        class_idx
        start_time
        end_time
        answer
        teacher_review_json
        score
        answer_image_url_json
        recording_data
        status
        rubric_data
        idate
        thread_id
        ai_homework {
          idx
          title
          description
          answer_rubric
          answer_key_image_urls
          page_count
        }
        user {
          idx
          id
          name
          view_id
        }
        class {
          idx
          name
        }
      }
    }
  }
`;
export const AI_HOMEWORK_DATE_ASSIGNMENT_LIST = gql`
  query aiHomeworkDateAssignmentList($class_idx: Int, $page: Int, $take: Int, $type: String, $start_date: String, $end_date: String) {
    aiHomeworkDateAssignmentList(class_idx: $class_idx, page: $page, take: $take, type: $type, start_date: $start_date, end_date: $end_date) {
      total
      page
      take
      ai_homework_date_assignments {
        idx
        data
        start_date
        limit_time
        idate
        ai_homework {
          idx
          title
          description
          answer_rubric
          answer_key_image_urls
          page_count
        }
        ai_homework_assignment_group {
          idx
          class {
            idx
            name
          }
        }
        ai_homework_user_assignments {
          idx
          user_idx
          status
        }
      }
    }
  }
`;

export const AI_HOMEWORK_USER_ASSIGNMENT_LIST = gql`
  query aiHomeWorkUserAssignmentList(
    $class_idx: Int
    $q: String
    $page: Int
    $take: Int
    $type: String
    $student_idx: Int
    $start_date: String
    $end_date: String
  ) {
    aiHomeWorkUserAssignmentList(
      class_idx: $class_idx
      q: $q
      page: $page
      take: $take
      type: $type
      student_idx: $student_idx
      start_date: $start_date
      end_date: $end_date
    ) {
      total
      page
      take
      ai_homework_user_assignments {
        idx
        class_idx
        start_time
        end_time
        answer
        score
        total_score
        answer_image_url_json
        recording_data
        status
        type
        rubric_data
        idate
        thread_id
        ai_request_responses {
          prompt_text
          completion_text
          data
          idate
        }
        ai_homework {
          idx
          title
          description
          answer_rubric
          answer_key_image_urls
          page_count
        }
        user {
          idx
          id
          name
        }
        class {
          idx
          name
        }
        ai_homework_date_assignment {
          idx
          start_date
          limit_time
          data
        }
      }
    }
  }
`;
